"use client";

import { useQuery } from "@tanstack/react-query";

import type { RecipeSearchPage } from "@/lib/recipes/types";

interface UseRecipeSearchOptions {
  q?: string;
  tags?: string[];
  scope?: string;
  enabled?: boolean;
}

export function useRecipeSearch({ q, tags, scope, enabled = true }: UseRecipeSearchOptions) {
  return useQuery<RecipeSearchPage>({
    queryKey: ["recipes", "search", q, tags, scope],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (q) params.set("q", q);
      if (tags && tags.length > 0) params.set("tags", tags.join(","));
      if (scope && scope !== "all") params.set("scope", scope);
      const res = await fetch(`/api/recipes/search?${params}`);
      if (!res.ok) throw new Error("Failed to search recipes");
      return res.json();
    },
    enabled,
  });
}
